import { REMOVE_CREATIVE } from './actionTypes';

const removeCreativeItemRow = id => ({
    type: REMOVE_CREATIVE,
    payload: id,
});

export default removeCreativeItemRow;
